<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useLocale } from '@/plugins/translation';
import WatchedVideos from '@/components/user-panel/WatchedVideos.vue';
import { useCustomerMgmt } from '@ilteducation/customer-mgmt';
import isArray from 'lodash/isArray';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const route = useRoute();
const router = useRouter();
const { t, l } = useLocale();
const { getItemByUid: getUserByUid } = useCustomerMgmt({ context: 'users' });

const tab = ref(0);
const userUid = ref<string>(isArray(route.params.userUid) ? route.params.userUid[0] : route.params.userUid);
const user = ref<{ name: string }>({ name: '...' });

onMounted(async () => {
  user.value = await getUserByUid(userUid.value);
});
</script>

<template>
  <v-container class="full-height pt-9">
    <v-row>
      <v-container class="custom-container">
        <v-row>
          <v-col class="pt-7 pb-9 pl-0">
            <h1 class="d-flex align-start">
              <v-btn
                size="default"
                class="px-0"
                variant="plain"
                @click="router.push({ name: 'myPage', hash: '#students' })"
              >
                <FontAwesomeIcon
                  color="black"
                  class="cursor-pointer"
                  size="xl"
                  icon="fa-solid fa-chevron-left"
                ></FontAwesomeIcon>
              </v-btn>
              {{ user.name }}
            </h1>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row>
      <v-tabs v-model="tab" class="user-page-tabs">
        <v-tab
          ><FontAwesomeIcon class="pr-2" icon="fa-regular fa-rotate-left"></FontAwesomeIcon
          >{{ t(l.user_page.watched_films_tab.tab_title) }}</v-tab
        >
      </v-tabs>
      <div class="tabs-content-frame bg-white mb-12">
        <v-window v-model="tab">
          <v-window-item>
            <v-container class="custom-container">
              <WatchedVideos :user-uid="userUid" is-student />
            </v-container>
          </v-window-item>
        </v-window>
      </div>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
@use '@/foundations/theme/settings';

h2 {
  line-height: 1.5;
}
.user-page-tabs {
  .v-tab {
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.3;
    padding: 0 40px;
    text-transform: none;
    letter-spacing: 0;
    transition: all 0.3s ease;
  }
  .v-slide-group-item--active {
    color: rgb(var(--v-theme-secondary)) !important;
    border-color: var(--v-gray-lighten2) !important;
    background: white !important;
  }
}

.tabs-content-frame {
  width: 100%;
  overflow: hidden;
}
</style>
